/** Спільні константи для UI: предмети, кольори, підписи станів. */

import { Calculator, Landmark, Languages, Layers } from 'lucide-react'

export const SUBJECTS = [
  {
    id: 'математика',
    label: 'Математика',
    short: 'Матем.',
    icon: Calculator,
    accent: 'text-sky-600 dark:text-sky-400',
    bg: 'bg-sky-100 text-sky-800 dark:bg-sky-950/60 dark:text-sky-200',
  },
  {
    id: 'історія',
    label: 'Історія України',
    short: 'Історія',
    icon: Landmark,
    accent: 'text-amber-600 dark:text-amber-400',
    bg: 'bg-amber-100 text-amber-900 dark:bg-amber-950/60 dark:text-amber-200',
  },
  {
    id: 'мова',
    label: 'Українська мова',
    short: 'Мова',
    icon: Languages,
    accent: 'text-emerald-600 dark:text-emerald-400',
    bg: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-950/60 dark:text-emerald-200',
  },
  {
    id: 'змішане',
    label: 'Змішане',
    short: 'Змішане',
    icon: Layers,
    accent: 'text-violet-600 dark:text-violet-400',
    bg: 'bg-violet-100 text-violet-900 dark:bg-violet-950/60 dark:text-violet-200',
  },
]

export const subjectById = (id) => SUBJECTS.find((s) => s.id === id) ?? SUBJECTS[3]

/** Стани картки в інтервальному повторенні. */
export const STATE_LABELS = {
  0: { label: 'Нова', color: 'bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-300' },
  1: { label: 'Вивчається', color: 'bg-rose-100 text-rose-800 dark:bg-rose-950/60 dark:text-rose-200' },
  2: { label: 'Повторення', color: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/60 dark:text-emerald-200' },
  3: { label: 'Повторити', color: 'bg-orange-100 text-orange-800 dark:bg-orange-950/60 dark:text-orange-200' },
}

/** Кнопки оцінки пам’яті — саме те, що описано в ТЗ. */
export const GRADE_BUTTONS = [
  {
    key: 'hard',
    grade: 'hard',
    label: 'Сложно',
    tone: 'rose',
    className: 'grade-button grade-hard',
    hint: 'Згадав, але важко',
  },
  {
    key: 'normal',
    grade: 'good',
    label: 'Нормально',
    tone: 'amber',
    className: 'grade-button grade-normal',
    hint: 'Згадав правильно',
  },
  {
    key: 'perfect',
    grade: 'easy',
    label: 'Идеально',
    tone: 'emerald',
    className: 'grade-button grade-perfect',
    hint: 'Згадав миттєво',
  },
]

/** Клавіші швидкого переходу між режимами. */
export const HOTKEYS = {
  reveal: ['Space', 'Enter'],
  hint: ['h'],
  speak: ['s'],
  flip: ['Space', 'Enter'],
  hard: ['1'],
  normal: ['2'],
  perfect: ['3'],
  again: ['4'],
  next: ['ArrowRight', 'n'],
  prev: ['ArrowLeft', 'p'],
  flipCard: ['f'],
}

/** Ліміти, які показуємо користувачу перед відправкою в Gemini. */
export const LIMITS = {
  maxFiles: 12,
  maxFileBytes: 14 * 1024 * 1024,
  maxTextChars: 60_000,
}

export const STORAGE_FILE_MAX = 900 * 1024

export const ACCEPTED_UPLOAD = '.pdf,.png,.jpg,.jpeg,.webp,.gif,.heic,image/*,application/pdf'
